import { faAddressBook } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";

const downloadVCF = () => {
  const contact = {
    fName: "9R NFC",
    lName: "Card",
    mobile: "+919925615191",
    email: "9rnfccard@gmail.com",
    address: {
      street:
        "234, 2th Floor, Silver Business Hub, BRTS Rd, Bapa Sitaram Chowk,",
      city: "Surat,",
      state: "Gujarat - ",
      postalCode: "395006.",
    },
    title: "NFC Card",
    company: "9R NFC",
    url: "https://9rnfc.com/",
    notes: "Next Generation Networking With 9R NFC Cards",
  };

  const googleMapsURL = "https://maps.app.goo.gl/K4yRYzsq7894JHGo9";

  const vcard = `BEGIN:VCARD
VERSION:3.0
FN:${contact.fName} ${contact.lName}
TEL;CELL:${contact.mobile}
EMAIL;HOME:${contact.email}
ADR;WORK:;;${contact.address.street};${contact.address.city};${contact.address.state};${contact.address.postalCode}
ORG;WORK:${contact.company}
TITLE:${contact.title}
URL:${contact.url}
NOTE:${contact.notes}
X-GOOGLE-MAPS-URL:${googleMapsURL}  
END:VCARD`;

  const blob = new Blob([vcard], { type: "text/vcard" });

  saveAs(blob, `${contact.fName} ${contact.lName}.vcf`);
};

const About = () => {
  return (
    <section className="px-lg-5 px-sm-5 px-4 pt-lg-5 pt-4 pb-0 bg2">
      <Container fluid>
        <Row>
          <Col
            lg={12}
            sm={12}
            md={12}
            className="pt-md-5 pt-sm-4 pt-0 d-flex flex-wrap justify-content-center"
          >
            <div className="contain">
              <h2 className="text-center AboutHeading1">9R NFC</h2>
              <h4 className="text-center AboutHeading2">NFC Smart Card</h4>
            </div>
          </Col>
          <div className="p-0">
            <h5 className="text-center fontcontain mt-2 mx-md-3 mx-sm-2 mx-0">
              "At 9RNFC, we live and breathe NFC! From NFC Tags and Products to
              Readers and Custom Solutions, we deliver worldwide. Whether you
              need hundreds, thousands, or even millions of units, we've got you
              covered. No project is too big!"
            </h5>
          </div>

          <div className="d-flex justify-content-center mt-3 mb-2">
            <Link
              to="/cardpage"
              variant="primary"
              size="lg"
              className="view-products-btn"
            >
              <span className="btn-text">View Products</span>
            </Link>
          </div>
        </Row>
      </Container>

      <section className="my-4 pb-3">
        <div className="container-lg">
          <Row>
            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 text-decoration-none"
                href="tel:+919925615191"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxcall px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-telephone-fill telephoneicn fs-1 ms-2 me-3"></i>
                    <div>Make a Call</div>
                  </div>
                </div>
              </a>
            </Col>

            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 text-decoration-none"
                href="https://wa.me/919925615191?text=Hello"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxwhatsapp px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-whatsapp whatsappicn fs-1 ms-2 me-3"></i>
                    <div>Chat On WhatsApp</div>
                  </div>
                </div>
              </a>
            </Col>

            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 text-decoration-none"
                href="https://www.instagram.com/9rnfc_com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxinsta px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-instagram instaicon fs-1 ms-2 me-3"></i>
                    <div>Visit Instagram</div>
                  </div>
                </div>
              </a>
            </Col>

            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 text-decoration-none"
                href="https://www.facebook.com/profile.php?id=61563096922232"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxfacebook px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-facebook facebookicon fs-1 ms-2 me-3"></i>
                    <div>Visit Facebook</div>
                  </div>
                </div>
              </a>
            </Col>

            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 text-decoration-none"
                href="https://www.linkedin.com/in/9r-nfc-b63aaa319/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxlinkedin px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-linkedin linkedinicon fs-1 ms-2 me-3"></i>
                    <div>Visit Linkedin</div>
                  </div>
                </div>
              </a>
            </Col>

            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 text-decoration-none"
                href="https://www.9rnfc.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxweb px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-globe2 webicon fs-1 ms-2 me-3"></i>
                    <div>Visit Website</div>
                  </div>
                </div>
              </a>
            </Col>

            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 text-decoration-none"
                href="https://maps.app.goo.gl/pyq989r7EDyyhNdu7"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxmap px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-geo-alt-fill mapicn fs-1 ms-2 me-3"></i>
                    <div>Visit Location</div>
                  </div>
                </div>
              </a>
            </Col>

            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 boxmap text-decoration-none"
                href="https://g.page/r/CZj1VUhWa2pHEAE/review"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxreview px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-star-fill reviewicn fs-1 ms-2 me-3"></i>
                    <div>Give Your Review</div>
                    <span className="ms-2">
                      <i className="bi bi-star-fill reviewicn fs-6"></i>
                      <i className="bi bi-star-fill reviewicn fs-6"></i>
                      <i className="bi bi-star-fill reviewicn fs-6"></i>
                      <i className="bi bi-star-fill reviewicn fs-6"></i>
                      <i className="bi bi-star-fill reviewicn fs-6"></i>
                    </span>
                  </div>
                </div>
              </a>
            </Col>

            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 text-decoration-none"
                href="https://youtube.com/@9rnfc?si=p9fETJNZjfODyvVD"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxyoutube px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-youtube youtubeticon fs-1 ms-2 me-3"></i>
                    <div>Visit YouTube</div>
                  </div>
                </div>
              </a>
            </Col>

            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 text-decoration-none"
                href="https://pin.it/2hJ5puZF9"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxpinterest px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-pinterest pinteresticon fs-1 ms-2 me-3"></i>
                    <div>Visit Pinterest</div>
                  </div>
                </div>
              </a>
            </Col>

            <Col xs={12} className="mb-lg-4 mb-3 contact_datails_01 p-0">
              <a
                className="AboutContacttxt2 text-decoration-none"
                href="mailto:9rnfccard@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="AboutContactDtl boxmail px-3 py-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="bi bi-envelope-fill mailicon fs-1 ms-2 me-3"></i>
                    <div>E-mail</div>
                  </div>
                </div>
              </a>
            </Col>
          </Row>

          <div className="mt-4 d-flex justify-content-center">
            <div className="row d-flex justify-content-center savecontactBtn">
              <div className="col-12 text-center">
                <div className="d-flex justify-content-center">
                  <a
                    href="#!"
                    onClick={downloadVCF}
                    className="savecontact_box text-decoration-none"
                  >
                    <span className="save-contact-btn d-flex">
                      <FontAwesomeIcon
                        icon={faAddressBook}
                        className="saveIcon savephoneicn"
                      />
                    </span>
                    <span>Save Contact</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default About;
